<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import { Icon } from "@iconify/vue2";

let user = JSON.parse(localStorage.getItem("user"));
let token = user.token;

export default {
  page: {
    title: "Döviz Listesi",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Icon },
  data() {
    return {
      isBusy: false,
      isButton: false,
      title: "Döviz Listesi",
      items: [
        {
          text: "RTS",
          href: "/",
        },
        {
          text: "Döviz Listesi",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      fields: [
        { key: "code", sortable: true, label: "Kodu" },
        { key: "name", sortable: true, label: "Döviz" },
        { key: "symbol", sortable: true, label: "Sembol" },
        { key: "total", sortable: true, label: "Tutar" },
        { key: "actions", label: "İşlemler" },
      ],
    };
  },
  methods: {
    getData(ctx, callback) {
      const params = "?page=" + ctx.currentPage;
      axios
        .get(process.env.VUE_APP_BASEURL + "/exchange" + params, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.data) {
            const items = response.data.data;
            this.totalRows = response.data.meta.total;
            this.perPage = response.data.meta.per_page;
            callback(items);
          }
        })
        .catch((error) => {
          callback([]);
          console.error("Veri yüklenirken bir hata oluştu:", error);
        });
      this.isBusy = false;
      return;
    },
    onPageChange(newPage) {
      this.currentPage = newPage;
    },
    editButton(index) {
      this.$router.push('/exchange/edit/' + index);
    },
    deleteButton(index) {
      this.isButton = true;
      const api_url = process.env.VUE_APP_BASEURL + '/exchange/' + index;
      axios
        .delete(api_url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          this.$refs.dataTable.refresh();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isButton = false;
        })
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between align-items-center mb-3">
                <h4 class="card-title m-0">Döviz Listesi</h4>
                <router-link to="/exchange/add" class="btn btn-primary">
                  <Icon icon="lucide:plus-circle" class="mr-1" /> Döviz Ekle
                </router-link>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table ref="dataTable" :items="getData" :fields="fields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :busy="isBusy">
                <template #table-busy>
                  <div class="d-flex flex-column align-items-center justify-content-center gap-1 my-2">
                    <Icon icon="lucide:loader" class="spinner-rotate" :style="{ fontSize: '72px' }" />
                  </div>
                </template>
                <template v-slot:cell(actions)="data">
                  <button @click="editButton(data.index)" class="btn btn-sm btn-secondary" :disabled="isButton">
                    Düzenle
                  </button>
                  <button @click="deleteButton(data.item.id)" class="btn btn-sm btn-danger ml-2" :disabled="isButton">
                    Sil
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
